export default __webpack_public_path__ + "static/media/kr.977537ff.svg";